import styled from 'styled-components';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

import { InputMoneyProps } from '../../interfaces/InputMoney.interface';

export const Container = styled.div<InputMoneyProps>`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  margin-bottom: 16px;
  padding: 8px 0;
`;

export const Label = styled.label<InputMoneyProps>`
  display: inline-block;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.gray100};
  font-size: 12px;
  line-height: 22px;
`;

export const InputContainer = styled.div<InputMoneyProps>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;

  input {
    font-size: 18px;
    font-family: 'Nunito', sans-serif;
    padding: 10px 15px 5px 0;
    border: 1px solid ${theme.colors.primary.transparentBorder};
    border-radius: 8px;
    padding: 16px;

    width: 100%;
    color: ${theme.colors.primary.black};
    &:focus {
      outline: none;
      border-color: ${theme.colors.primary.bariBlue};
    }
  }
`;

export const ComponentTooltip = styled.div`
  position: relative;
  display: inline-block;
  :hover {
    span {
      visibility: visible;
    }
  }
`;

export const MessageTooltipText = styled.span`
  visibility: hidden;
  background: #101010;
  width: 196px;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  line-height: 16px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  position: absolute;
  z-index: 1;
  box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 8px 24px;
  bottom: 130%;
  left: 57%;
  margin-left: -104px;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #101010 transparent transparent transparent;
    right: 88px;
  }

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    right: 144%;
    left: auto;
    margin-left: 0;
    bottom: -9px;

    &::after {
      top: 40%;
      left: auto;
      border-color: transparent transparent transparent #101010;
      bottom: 50%;
      right: -10px;
    }
  }
`;

export const SubLabelText = styled.p<InputMoneyProps>`
  display: flex;
  justify-content: space-between;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  color: ${theme.colors.secondary.gray300};
  margin: 0 0 8px 0;
`;

export const Error = styled.span`
  display: flex;
  color: ${theme.colors.secondary.red200};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;
